// extracted by mini-css-extract-plugin
export default {"row":"OrderCartItem_row__5kPaJ"};